module.exports = {
	url: '/employment',
	template: require('raw!templates/employment/employment-view.html'),
	controller: employmentController,
	controllerAs: 'employmentCtrl',
};

function employmentController(contentful, $window, $state, $http, $timeout, $scope) {
	var vm = this;
	$window.scrollTo(0, 0);
	vm.showForm = true;
	vm.showConfirmationLayer = false;
	vm.showErrorLayer = false;

	vm.submitForm = function(formValid) {
		if (formValid) {
			var postUrl = "/api/contact";
			var reason = "test";
			var obj = {
				fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
				fromEmail: vm.contactForm.email,
				toName: 'Guest Services',
				toEmail: 'guestservices@parkcitypeaks.com',
				subject: 'Employment Inquiry',
				emailBody: vm.contactForm.comments,
				emailAttachments: vm.contactForm.cv + ' ' + vm.contactForm.resume
			};
			$http.post(postUrl, obj).then(function success(res) {
				console.log('success: ', res);
				vm.showForm = false;
				vm.showConfirmationLayer = true;
				// $timeout(function() {
				// 	vm.contactForm = '';
				// 	vm.showConfirmationLayer = false;
				// }, 10000);
			}, function error(err) {
				console.log('error: ', err)
				window.glob = err;
				vm.showErrorLayer = true;
				$timeout(function() {
					vm.contactForm = '';
					vm.showErrorLayer = false;
				}, 5000);
			});
		} else {
			console.log("form invalid");
		}
	};
}



// WEBPACK FOOTER //
// ./components/templates/employment/employment-controller.js